import axios from 'axios'

var api = process.env.VUE_APP_API

// rough bounding boxes for the United States — used to suppress distance for
// overseas visitors, for whom a straight-line figure (and no drivable route)
// is meaningless
var US_BOUNDS = [
	{ minLat: 24.4, maxLat: 49.4, minLng: -125.0, maxLng: -66.9 }, // continental
	{ minLat: 51.0, maxLat: 71.6, minLng: -179.2, maxLng: -129.0 }, // Alaska
	{ minLat: 18.9, maxLat: 22.3, minLng: -160.3, maxLng: -154.8 }  // Hawaii
]

// drive-time lookups batched per tick so a list of locations becomes one
// request; promises memoized per location + rounded origin for the session
var cache = {}
var queue = {}
var timer = false

// the admin's search text for a multi-place embed lives in a !2m1!1s segment
// of the Google Maps embed URL (e.g. "Staples Lafayette, Colorado") — far more
// precise than the bare location title
function embedQuery(map) {

	if (!map) return ''

	var m = map.match(/!2m\d+!1s([^!"]+)/)

	if (!m) return ''

	try {
		return decodeURIComponent(m[1]).trim()
	} catch (e) {
		return ''
	}

}

// a single-place embed names the business in the !2s segment immediately
// after its place token (!1s0x...:0x...) - this is the labelled place the
// embed shows, so directing to it (rather than raw coordinates) lands the
// visitor on the same pin instead of a bare dropped marker
function placeName(map) {

	if (!map) return ''

	var m = map.match(/!1s0x[0-9a-f]+(?::|%3a)0x[0-9a-f]+!2s([^!"]+)/i)

	if (!m) return ''

	try {
		return decodeURIComponent(m[1]).trim()
	} catch (e) {
		return ''
	}

}

function originKey(position) {

	return position.lat.toFixed(3) + ',' + position.lng.toFixed(3)

}

function flush() {

	timer = false

	var batches = queue

	queue = {}

	Object.keys(batches).forEach(function(batch) {

		var pending = batches[batch]
		var parts = batch.split('|')

		axios.get(api + 'drivetime/' + parts[0] + '.json', {
			params: {
				origin: parts[1],
				locations: Object.keys(pending).join(',')
			}
		}).then(function(response) {

			var times = (response.data.data) ? response.data.data.times : {}

			Object.keys(pending).forEach(function(id) {

				pending[id]((times && times[id] !== undefined) ? times[id] : null)

			})

		}, function() {

			Object.keys(pending).forEach(function(id) {

				pending[id](null)

			})

		})

	})

}

export default {

	haversineMiles: function(from, to) {

		var radians = Math.PI / 180
		var dLat = (to.lat - from.lat) * radians
		var dLng = (to.lng - from.lng) * radians

		var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(from.lat * radians) * Math.cos(to.lat * radians) * Math.sin(dLng / 2) * Math.sin(dLng / 2)

		return 3958.761 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

	},

	formatMiles: function(miles) {

		var value = (miles < 10) ? Math.max(0.1, Math.round(miles * 10) / 10) : Math.round(miles)

		return value + ((value === 1) ? ' mile' : ' miles')

	},

	formatMinutes: function(minutes) {

		var value = Math.max(1, Math.round(minutes))

		return value + ((value === 1) ? ' minute' : ' minutes')

	},

	// resolves {miles, minutes} or null, never rejects
	driveTime: function(key, position, id) {

		var origin = originKey(position)
		var cacheKey = key + '|' + origin + '|' + id

		if (cache[cacheKey]) return cache[cacheKey]

		cache[cacheKey] = new Promise(function(resolve) {

			var batch = key + '|' + origin

			if (!queue[batch]) queue[batch] = {}

			queue[batch][id] = resolve

			if (!timer) timer = setTimeout(flush, 50)

		})

		return cache[cacheKey]

	},

	isInUS: function(position) {

		if (!position) return false

		return US_BOUNDS.some(function(b) {

			return position.lat >= b.minLat && position.lat <= b.maxLat && position.lng >= b.minLng && position.lng <= b.maxLng

		})

	},

	directionsUrl: function(location) {

		// single place -> direct to the embed's named business so Google
		// shows the same labelled pin the embed does; the coordinate is only
		// a fallback for embeds with no recoverable place name (legacy q=/ll=)
		if (location.lat !== null && location.lat !== undefined) {

			var name = placeName(location.map)

			if (name) {

				return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(name)

			}

			return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(location.lat + ',' + location.lng)

		}

		// search embed (several places) -> open the same map the embed shows,
		// using the admin's search query so the visitor can pick a location
		if (location.multiple) {

			return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(embedQuery(location.map) || location.title)

		}

		// embed without parsed coordinates -> directions to the title
		return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(location.title)

	}

}
